var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_965_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4043 8.125C16.4043 9.91797 15.8223 11.5742 14.8418 12.918L19.7871 17.8672C20.2754 18.3555 20.2754 19.1484 19.7871 19.6367C19.2988 20.125 18.5059 20.125 18.0176 19.6367L13.0723 14.6875C11.7285 15.6719 10.0723 16.25 8.2793 16.25C3.79102 16.25 0.154297 12.6133 0.154297 8.125C0.154297 3.63672 3.79102 0 8.2793 0C12.7676 0 16.4043 3.63672 16.4043 8.125ZM8.2793 13.75C9.01798 13.75 9.74943 13.6045 10.4319 13.3218C11.1143 13.0391 11.7344 12.6248 12.2568 12.1025C12.7791 11.5801 13.1934 10.96 13.4761 10.2776C13.7588 9.59514 13.9043 8.86368 13.9043 8.125C13.9043 7.38631 13.7588 6.65486 13.4761 5.9724C13.1934 5.28995 12.7791 4.66985 12.2568 4.14752C11.7344 3.62519 11.1143 3.21086 10.4319 2.92818C9.74943 2.64549 9.01798 2.5 8.2793 2.5C7.54061 2.5 6.80916 2.64549 6.1267 2.92818C5.44425 3.21086 4.82415 3.62519 4.30182 4.14752C3.77949 4.66985 3.36516 5.28995 3.08247 5.9724C2.79979 6.65486 2.6543 7.38631 2.6543 8.125C2.6543 8.86368 2.79979 9.59514 3.08247 10.2776C3.36516 10.96 3.77949 11.5801 4.30182 12.1025C4.82415 12.6248 5.44425 13.0391 6.1267 13.3218C6.80916 13.6045 7.54061 13.75 8.2793 13.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_965_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.154297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchQuestion);
export default __webpack_public_path__ + "static/media/search-question.cbfbca9b9972d067e791260de9692882.svg";
export { ForwardRef as ReactComponent };